import { useEffect, useRef, useState, useMemo } from "react";
import { FaCalendarCheck, FaWhatsapp } from "react-icons/fa";
import { GrFormView } from "react-icons/gr";
import { HiOutlinePhoneMissedCall } from "react-icons/hi";
import { SlCallOut } from "react-icons/sl";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Webcam from "react-webcam";
import LoaderSpiner from "../Components/LoaderSpiner";
import styles from "./Styles/CreateElectionOutBoundAgentComponent.module.css";

const languages = [
  { value: "en-US", name: "English (United States)" },
  { value: "en-IN", name: "English (India)" },
  { value: "en-GB", name: "English (United Kingdom)" },
  { value: "en-AU", name: "English (Australia)" },
  { value: "en-NZ", name: "English (New Zealand)" },
  { value: "hi", name: "Hindi" },
  { value: "ar", name: "Arabic" },
  { value: "es", name: "Spanish" },
  { value: "pl", name: "Polish" },
  { value: "pt", name: "Portuguese" },
  { value: "ta", name: "Tamil" },
  { value: "ro", name: "Romanian" },
  { value: "fi", name: "Finnish" },
  { value: "el", name: "Greek" },
  { value: "bg", name: "Bulgarian" },
  { value: "vi", name: "Vietnamese" },
  { value: "cs", name: "Czech" },
  { value: "no", name: "Norwegian" },
  { value: "fr", name: "French" },
  { value: "de", name: "German" },
  { value: "ja", name: "Japanese" },
  { value: "ru", name: "Russian" },
  { value: "it", name: "Italian" },
  { value: "sv", name: "Swedish" },
  { value: "nl", name: "Dutch" },
  { value: "uk", name: "Ukrainian" },
  { value: "tr", name: "Turkish" },
  { value: "zh", name: "Chinese" },
];

const templateImages = [
  "/avatar1.jpg",
  "/avatar2.jpg",
  "/avatar3.jpg",
  "/avatar4.jpg",
  "/avatar5.png",
  "/avatar6",
  "/avatar7.webp",
  "/avatar8.webp",
  "/avatar9.webp",
];

const CreateElectionOutBoundAgentComponent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [avatarName, setAvatarName] = useState("");
  const [avatarPrefix, setAvatarPrefix] = useState("");
  const [avatarImage, setAvatarImage] = useState(null);
  const [language, setLanguage] = useState("");
  const [gender, setGender] = useState("");
  const [voice, setVoice] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [model, setModel] = useState("");
  const [systemPrompt, setSystemPrompt] = useState("");
  const [temperature, setTemperature] = useState(0.3);
  const [firstSpeaking, setFirstSpeaking] = useState(false);
  const [welcomeMessage, setWelcomeMessage] = useState("");
  const [maxDuration, setMaxDuration] = useState("");
  const [timeExceedMessage, setTimeExceedMessage] = useState("");
  const [transcript, setTranscript] = useState(true);
  const [callRecording, setCallRecording] = useState(true);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [isLoadingNumbers, setIsLoadingNumbers] = useState(false);
  const [numberError, setNumberError] = useState("");
  const [voices, setVoices] = useState([]);
  const [isLoadingVoices, setIsLoadingVoices] = useState(false);
  const [voiceError, setVoiceError] = useState("");
  const [voiceSearch, setVoiceSearch] = useState("");
  const [prompts, setPrompts] = useState([]);
  const [isLoadingPrompts, setIsLoadingPrompts] = useState(false);
  const [promptError, setPromptError] = useState("");
  const [knowledgeBases, setKnowledgeBases] = useState([]);
  const [isLoadingKnowledgeBases, setIsLoadingKnowledgeBases] = useState(false);
  const [knowledgeBaseError, setKnowledgeBaseError] = useState("");
  const [corpusId, setCorpusId] = useState("");
  const [corpora, setCorpora] = useState([]);
  const [isLoadingCorpora, setIsLoadingCorpora] = useState(false);
  const [corpusError, setCorpusError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showCalcomPopup, setShowCalcomPopup] = useState(false);
  const [calcomToken, setCalcomToken] = useState("");
  const [showCallTransferPopup, setShowCallTransferPopup] = useState(false);
  const [callTransferNumber, setCallTransferNumber] = useState("");
  const [showWhatsappPopup, setShowWhatsappPopup] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [showTemplatePopup, setShowTemplatePopup] = useState(false);
  const [mode, setMode] = useState("outbound");
  const [bookCalendar, setBookCalendar] = useState(false);
  const [whatsapp, setWhatsapp] = useState(false);
  const [callTransfer, setCallTransfer] = useState(false);
  const [showAvatarPanel, setShowAvatarPanel] = useState(false);
  const [showCamera, setShowCamera] = useState(false);
  const [inactivityMessages, setInactivityMessages] = useState([
    { duration: "10", message: "Hey, are you still there?" },
  ]);
  const webcamRef = useRef(null);
  const token = localStorage.getItem("token");
  const voicesPerPage = 5;

  // Pre-set system prompt
  useEffect(() => {
    if (location.state?.selectedPromptId) {
      setSystemPrompt(location.state.selectedPromptId);
    }
  }, [location.state]);

  // Infer language from displayName
  const getVoiceLanguage = (displayName) => {
    if (displayName.includes("En (Indian)")) return "en-IN";
    if (displayName.includes("En (British)")) return "en-GB";
    if (displayName.includes("En (Australian)")) return "en-AU";
    if (displayName.includes("En (NewZealand)")) return "en-NZ";
    if (displayName.includes("-En") || displayName.includes("En ")) return "en-US";
    if (displayName.includes("Hi (Urdu)") || displayName.includes("-Hi")) return "hi";
    if (displayName.includes("Ar (Egyptian)") || displayName.includes("-Ar")) return "ar";
    if (displayName.includes("-Sp")) return "es";
    if (displayName.includes("-Po")) return "pl";
    if (displayName.includes("Br (Portuguese)")) return "pt";
    if (displayName.includes("-Ta")) return "ta";
    if (displayName.includes("-Ro")) return "ro";
    if (displayName.includes("-Fi")) return "fi";
    if (displayName.includes("-Gr")) return "el";
    if (displayName.includes("-Bu")) return "bg";
    if (displayName.includes("-Vi")) return "vi";
    if (displayName.includes("-Cz")) return "cs";
    if (displayName.includes("-No")) return "no";
    if (displayName.includes("-Fr")) return "fr";
    if (displayName.includes("-Ge")) return "de";
    if (displayName.includes("-Ja")) return "ja";
    if (displayName.includes("-Ru")) return "ru";
    if (displayName.includes("-It")) return "it";
    if (displayName.includes("-Sw")) return "sv";
    if (displayName.includes("-Du")) return "nl";
    if (displayName.includes("-Uk")) return "uk";
    if (displayName.includes("-Tu")) return "tr";
    if (displayName.includes("-Ch")) return "zh";
    return null;
  };

  // Filter voices
  const filteredVoices = useMemo(() => {
    return voices.filter((v) => {
      const voiceLanguage = getVoiceLanguage(v.displayName);
      const matchesGender =
        !gender ||
        v.gender?.toLowerCase() === gender.toLowerCase() ||
        v.gender === "Unknown";
      const matchesLanguage = !language || (voiceLanguage && voiceLanguage === language);
      const matchesSearch =
        !voiceSearch ||
        v.displayName.toLowerCase().includes(voiceSearch.toLowerCase());
      return matchesGender && matchesLanguage && matchesSearch;
    });
  }, [gender, language, voiceSearch, voices]);

  const indexOfLastVoice = currentPage * voicesPerPage;
  const indexOfFirstVoice = indexOfLastVoice - voicesPerPage;
  const currentVoices = filteredVoices.slice(indexOfFirstVoice, indexOfLastVoice);
  const totalPages = Math.ceil(filteredVoices.length / voicesPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Fetch phone numbers
  useEffect(() => {
    const fetchNumbers = async () => {
      setIsLoadingNumbers(true);
      setNumberError("");
      try {
        const userId = localStorage.getItem("userId");
        if (!userId) throw new Error("userId not found");
        const response = await fetch(
          `https://prod.toxboxai.com/api/election-number/by-purchase-person/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch numbers");
        const data = await response.json();
        setPhoneNumbers(Array.isArray(data.numbers) ? data.numbers : []);
      } catch (err) {
        setNumberError("Failed to load phone numbers");
        setPhoneNumbers([]);
      } finally {
        setIsLoadingNumbers(false);
      }
    };
    if (token) fetchNumbers();
  }, [token]);

  // Fetch voices
  useEffect(() => {
    const fetchVoices = async () => {
      setIsLoadingVoices(true);
      setVoiceError("");
      try {
        const response = await fetch(
          "https://prod.toxboxai.com/api/voice/get-voice-by-display-name",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch voices");
        const data = await response.json();
        setVoices(Array.isArray(data) ? data : []);
      } catch (err) {
        setVoiceError("Failed to load voices");
        setVoices([]);
      } finally {
        setIsLoadingVoices(false);
      }
    };
    if (token) fetchVoices();
  }, [token]);

  // Fetch corpora
  useEffect(() => {
    const fetchCorpora = async () => {
      setIsLoadingCorpora(true);
      setCorpusError("");
      try {
        const userId = localStorage.getItem("userId");
        if (!userId) throw new Error("userId not found");
        const response = await fetch(
          `https://prod.toxboxai.com/api/vendorknowledge/get-assigned-corpus/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch corpora");
        const data = await response.json();
        setCorpora(Array.isArray(data.results) ? data.results : []);
      } catch (err) {
        setCorpusError("Failed to load corpora");
        setCorpora([]);
      } finally {
        setIsLoadingCorpora(false);
      }
    };
    if (token) fetchCorpora();
  }, [token]);

  // Fetch prompts
  useEffect(() => {
    const fetchPrompts = async () => {
      setIsLoadingPrompts(true);
      setPromptError("");
      try {
        const response = await fetch(
          `https://prod.toxboxai.com/api/prompt-template/get-templates-by-creator`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch prompt templates");
        const data = await response.json();
        setPrompts(Array.isArray(data.templates) ? data.templates : []);
      } catch (err) {
        setPromptError("Failed to load prompt templates");
      } finally {
        setIsLoadingPrompts(false);
      }
    };
    if (token) fetchPrompts();
  }, [token]);

  // Fetch knowledge bases
  useEffect(() => {
    const fetchKnowledgeBases = async () => {
      setIsLoadingKnowledgeBases(true);
      setKnowledgeBaseError("");
      try {
        const userId = localStorage.getItem("userId");
        if (!userId) throw new Error("userId not found");
        const response = await fetch(
          `https://prod.toxboxai.com/api/knowledge-base/get-knowledgeBase-by-creator/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.ok) throw new Error("Failed to fetch knowledge bases");
        const data = await response.json();
        setKnowledgeBases(Array.isArray(data.knowledgeBases) ? data.knowledgeBases : []);
      } catch (err) {
        setKnowledgeBaseError("Failed to load knowledge bases");
        setKnowledgeBases([]);
      } finally {
        setIsLoadingKnowledgeBases(false);
      }
    };
    if (token) fetchKnowledgeBases();
  }, [token]);

  const handleFileUpload = (e) => {
    if (e.target.files && e.target.files[0]) {
      setAvatarImage(e.target.files[0]);
      setShowAvatarPanel(false);
    }
  };

  const handleAvatarSelect = (imgUrl) => {
    setAvatarImage(imgUrl);
    setShowAvatarPanel(false);
  };

  const capturePhoto = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      setAvatarImage(imageSrc);
      setShowCamera(false);
    }
  };

  const cancelCamera = () => {
    setShowCamera(false);
  };

  const handleVoiceSelect = (displayName) => {
    setVoice(displayName);
    setCurrentPage(1);
  };

  const handlePreview = () => {
    if (!voice) {
      toast.error("Please select a voice first");
      return;
    }
    navigate("/playground", {
      state: { voice, prompt: systemPrompt },
    });
  };

  const handleTemplateImageSelect = (imageUrl) => {
    setAvatarImage(imageUrl);
    setShowTemplatePopup(false);
  };

  // Inactivity message handlers
  const handleInactivityMessageChange = (index, field, value) => {
    setInactivityMessages((prev) =>
      prev.map((msg, i) =>
        i === index ? { ...msg, [field]: value } : msg
      )
    );
  };

  const addInactivityMessage = () => {
    setInactivityMessages((prev) => [
      ...prev,
      { duration: "", message: "" },
    ]);
  };

  const removeInactivityMessage = (index) => {
    if (inactivityMessages.length === 1) {
      toast.error("At least one inactivity message is required");
      return;
    }
    setInactivityMessages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!avatarName.trim() || !phoneNumber || !voice || !systemPrompt) {
      toast.error("Please fill all required fields");
      return;
    }

    // Validate inactivity messages
    for (const msg of inactivityMessages) {
      if (!msg.duration || !msg.message) {
        toast.error("Please fill all inactivity durations and messages");
        return;
      }
      if (isNaN(msg.duration) || Number(msg.duration) <= 0) {
        toast.error("All inactivity durations must be positive numbers");
        return;
      }
    }

    try {
      const payload = {
        avatarName: avatarPrefix ? `${avatarPrefix}-${avatarName}` : avatarName,
        avatarImage: typeof avatarImage === "string" ? avatarImage : null,
        language,
        gender,
        voice,
        phoneNumber,
        model,
        systemPrompt,
        temperature: parseFloat(temperature),
        firstSpeaking,
        firstSpeakerSettings: {
          agent: {
            text: welcomeMessage || "Hi there! How can I help you?",
          },
        },
        welcomeMessage,
        maxDuration: maxDuration ? `${maxDuration}s` : "",
        timeExceedMessage,
        transcript,
        callRecording,
        type: "outbound",
        whatsapp,
        whatsappNumber: whatsappNumber || "",
        callTransfer,
        callTransferNumber: callTransferNumber || "",
        bookCalendar,
        calcomToken: calcomToken,
        inactivityMessages: inactivityMessages.map((msg) => ({
          duration: `${msg.duration}s`,
          message: msg.message,
        })),
      };

      const response = await fetch(
        `https://prod.toxboxai.com/api/election-agent/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) throw new Error("Failed to create election agent");

      toast.success("Election agent created successfully");
      navigate("/agents-template");
    } catch (error) {
      console.error("Error creating election agent:", error);
      toast.error("Error creating election agent");
    }
  };

  const generateRandomPrefix = () => {
    const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let result = "";
    for (let i = 0; i < 3; i++) {
      result += letters.charAt(Math.floor(Math.random() * letters.length));
    }
    return result;
  };

  const handleAvatarNameChange = (e) => {
    const name = e.target.value.replace(`${avatarPrefix}-`, "");
    if (!avatarPrefix && name) {
      setAvatarPrefix(generateRandomPrefix());
    }
    setAvatarName(name);
  };

  const modelOptions = [
    { label: "Ultimate", value: "Ultimate" },
    { label: "Advanced", value: "Advanced" },
    { label: "Elite", value: "Elite" },
    { label: "Max", value: "Max" },
  ];

  useEffect(() => {
    const handlePlay = (event) => {
      const audioElements = document.querySelectorAll("audio");
      audioElements.forEach((audio) => {
        if (audio !== event.target) {
          audio.pause();
          audio.currentTime = 0;
        }
      });
    };

    document.addEventListener("play", handlePlay, true);
    return () => document.removeEventListener("play", handlePlay, true);
  }, []);

  return (
    <div className={styles.pageContainer}>
      <div className={styles.container}>
        <div className={styles.headerWrap}>
          <h1 className={styles.header}>Create Outbound Agent</h1>
          {location?.state?.selectedPromptName && (
            <p>Agent for {location.state.selectedPromptName}</p>
          )}
        </div>

        <form className={styles.formCard} onSubmit={handleSubmit}>
          <div className={styles.gridWrap}>
            <div className={styles.section}>
              <h2 className={styles.sectionTitle}>Basic Information</h2>
              <div className={styles.fieldGroup}>
                <div className={styles.fieldWrap}>
                  <label className={styles.label}>
                    Avatar Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className={styles.input}
                    placeholder="Enter avatar name with Campaign name"
                    value={avatarPrefix ? `${avatarPrefix}-${avatarName}` : avatarName}
                    onChange={handleAvatarNameChange}
                    aria-label="Avatar Name"
                  />
                </div>

                <div className={styles.fieldWrap}>
                  <label className={styles.label}>Language</label>
                  <select
                    className={styles.input}
                    value={language}
                    onChange={(e) => {
                      setLanguage(e.target.value);
                      setCurrentPage(1);
                    }}
                    aria-label="Language"
                  >
                    <option value="">Select language</option>
                    {languages.map((lang) => (
                      <option key={lang.value} value={lang.value}>
                        {lang.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.fieldWrap}>
                  <label className={styles.label}>Avatar Image</label>
                  <div
                    className={styles.uploadWrap}
                    onClick={() => setShowAvatarPanel(true)}
                  >
                    {avatarImage ? (
                      <img
                        src={
                          typeof avatarImage === "string"
                            ? avatarImage.startsWith("http")
                              ? avatarImage
                              : `https://prod.toxboxai.com${avatarImage}`
                            : URL.createObjectURL(avatarImage)
                        }
                        alt="Avatar Preview"
                        className={styles.avatarPreview}
                        onError={(e) => {
                          e.target.src = "https://via.placeholder.com/150?text=No+Image";
                        }}
                      />
                    ) : (
                      <span className={styles.uploadIcon}>Upload Image</span>
                    )}
                  </div>
                </div>

                {showAvatarPanel && (
                  <div
                    className={styles.sidePanelOverlay}
                    onClick={() => setShowAvatarPanel(false)}
                  >
                    <div
                      className={styles.sidePanel}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <h3 className={styles.sidePanelTitle}>Choose an Avatar</h3>
                      <div className={styles.avatarGrid}>
                        {templateImages.map((img, index) => (
                          <img
                            key={index}
                            src={img}
                            alt={`avatar-${index}`}
                            className={styles.avatarOption}
                            onClick={() => handleAvatarSelect(img)}
                            onError={(e) => {
                              e.target.src = "https://via.placeholder.com/150?text=No+Image";
                            }}
                          />
                        ))}
                      </div>
                      <label className={styles.uploadButton}>
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={handleFileUpload}
                        />
                        Upload Custom Image
                      </label>
                      <button
                        className={styles.cameraButton}
                        onClick={() => setShowCamera(true)}
                      >
                        Capture with Camera
                      </button>
                      {showCamera && (
                        <div className={styles.cameraOverlay}>
                          <div className={styles.cameraContainer}>
                            <Webcam
                              audio={false}
                              ref={webcamRef}
                              screenshotFormat="image/jpeg"
                              className={styles.cameraFeed}
                            />
                            <div className={styles.cameraButtons}>
                              <button
                                onClick={capturePhoto}
                                className={styles.captureButton}
                              >
                                Capture
                              </button>
                              <button
                                onClick={cancelCamera}
                                className={styles.cancelButton}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        </div>
                      )}
                      <button
                        className={styles.cancelButton}
                        onClick={() => setShowAvatarPanel(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}

                <div className={styles.fieldWrap}>
                  <label className={styles.label}>
                    Phone Number <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className={styles.input}
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    disabled={isLoadingNumbers || !!numberError}
                    aria-label="Phone Number"
                  >
                    <option value="">
                      {isLoadingNumbers ? "Loading numbers..." : numberError ? numberError : "Select phone number"}
                    </option>
                    {phoneNumbers.map((phoneObj) => (
                      <option key={phoneObj._id} value={phoneObj.phoneNumber}>
                        {phoneObj.phoneNumber}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.fieldWrap}>
                  <label className={styles.label}>Gender</label>
                  <select
                    className={styles.input}
                    value={gender}
                    onChange={(e) => {
                      setGender(e.target.value);
                      setCurrentPage(1);
                    }}
                    aria-label="Gender"
                  >
                    <option value="">Select gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="unknown">Unknown</option>
                  </select>
                </div>
              </div>
            </div>

            <div className={styles.section}>
              <h2 className={styles.sectionTitle}>
                Voice Selection <span style={{ color: "red" }}>*</span>
              </h2>
              {voice && (
                <div className={styles.selectedVoiceInfo}>
                  <strong>Currently Selected:</strong> {voice}
                  <button
                    type="button"
                    className={styles.clearVoiceBtn}
                    onClick={() => setVoice("")}
                  >
                    Clear
                  </button>
                </div>
              )}
              <div className={styles.voiceSelectionWrapper}>
                <div className={styles.fieldWrap}>
                  <label className={styles.label}>Search Voices</label>
                  <input
                    type="text"
                    className={styles.input}
                    placeholder="Search by voice name..."
                    value={voiceSearch}
                    onChange={(e) => {
                      setVoiceSearch(e.target.value);
                      setCurrentPage(1);
                    }}
                    disabled={isLoadingVoices}
                    aria-label="Search Voices"
                  />
                </div>
                {isLoadingVoices ? (
                  <LoaderSpiner />
                ) : voiceError ? (
                  <div className={styles.error}>
                    <p>{voiceError}</p>
                  </div>
                ) : voices.length === 0 ? (
                  <p className={styles.noVoices}>No voices available</p>
                ) : (
                  <>
                    <table className={styles.voiceTable}>
                      <thead>
                        <tr>
                          <th>Display Name</th>
                          <th>Gender</th>
                          <th>Language</th>
                          <th>Preview</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentVoices.map((v) => (
                          <tr key={v._id}>
                            <td>{v.displayName}</td>
                            <td>{v.gender || "Unknown"}</td>
                            <td>{getVoiceLanguage(v.displayName) || "Unknown"}</td>
                            <td>
                              <audio
                                controls
                                className={styles.audioPreview}
                                preload="metadata"
                                onPlay={() =>
                                  document.getElementById("voiceOverlay")?.classList.add(styles.playing)
                                }
                                onPause={() =>
                                  document.getElementById("voiceOverlay")?.classList.remove(styles.playing)
                                }
                              >
                                <source
                                  src={`https://prod.toxboxai.com${v.previewUrl}`}
                                  type="audio/mpeg"
                                />
                                Your browser does not support the audio element.
                              </audio>
                            </td>
                            <td>
                              <button
                                type="button"
                                className={`${styles.selectButton} ${voice === v.displayName ? styles.selectedVoiceButton : ""
                                  }`}
                                onClick={() => handleVoiceSelect(v.displayName)}
                                disabled={voice === v.displayName}
                              >
                                {voice === v.displayName ? "✓ Selected" : "Select"}
                              </button>
                            </td>
                          </tr>
                        ))}
                        {currentVoices.length === 0 && (
                          <tr>
                            <td colSpan="5" className={styles.noVoices}>
                              No voices match the selected criteria
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    {totalPages > 1 && (
                      <div className={styles.pagination}>
                        <button
                          type="button"
                          className={styles.paginationButton}
                          onClick={() => paginate(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          Prev
                        </button>
                        <span>{currentPage} of {totalPages}</span>
                        <button
                          type="button"
                          className={styles.paginationButton}
                          onClick={() => paginate(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </>
                )}
                <div className={styles.voiceOverlay} id="voiceOverlay">
                  <div className={styles.waveOverlayCenter}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.section}>
              <h2 className={styles.sectionTitle}>Agent Configuration</h2>
              <div className={styles.fieldGroup}>
                <div className={styles.fieldWrap}>
                  <label className={styles.label}>Model</label>
                  <select
                    className={styles.input}
                    value={model}
                    onChange={(e) => setModel(e.target.value)}
                    aria-label="Model"
                  >
                    <option value="">Select model</option>
                    {modelOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.fieldWrap}>
                  <label className={styles.label}>
                    System Prompt <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    className={styles.input}
                    value={systemPrompt}
                    onChange={(e) => setSystemPrompt(e.target.value)}
                    disabled={true}
                    aria-label="System Prompt"
                  >
                    <option value="">
                      {isLoadingPrompts ? "Loading prompts..." : promptError ? promptError : "Select system prompt"}
                    </option>
                    {prompts.map((p) => (
                      <option key={p._id} value={p._id}>
                        {p.promptName}
                      </option>
                    ))}
                  </select>
                  {promptError && <p className={styles.error}>{promptError}</p>}
                </div>

                <div className={styles.fieldWrap}>
                  <label className={styles.label}>
                    Temperature (0.1 - 1.0)
                    <span style={{ color: "red" }}>*</span>
                    <span className={styles.tooltipContainer}>
                      <GrFormView className={styles.viewicon} />
                      <span className={styles.tooltipText}>
                        Temperature controls the randomness of responses.<br />
                        Lower values (e.g., 0.1) make output more focused and deterministic.<br />
                        Higher values (e.g., 1.0) make output more creative and diverse.
                      </span>
                    </span>
                  </label>
                  <div className={styles.sliderWrapper}>
                    <input
                      type="range"
                      min={0.1}
                      max={1.0}
                      step={0.1}
                      value={temperature}
                      onChange={(e) => setTemperature(Number(e.target.value))}
                      className={styles.slider}
                      aria-label="Temperature"
                    />
                    <span className={styles.sliderValue}>{temperature}</span>
                  </div>
                </div>

                <div className={styles.toggleCard}>
                  <div className={styles.toggleLabelWrap}>
                    <span className={styles.label}>First Speaking:</span>
                    <div className={styles.toggleOptions}>
                      <span
                        className={!firstSpeaking ? styles.activeToggle : styles.inactiveToggle}
                      >
                        User
                      </span>
                      <span
                        className={firstSpeaking ? styles.activeToggle : styles.inactiveToggle}
                      >
                        Agent
                      </span>
                    </div>
                    <label className={styles.switch}>
                      <input
                        type="checkbox"
                        checked={firstSpeaking}
                        onChange={() => setFirstSpeaking(!firstSpeaking)}
                        aria-label="First Speaking"
                      />
                      <span className={styles.sliderSwitch}></span>
                    </label>
                  </div>
                </div>

                {firstSpeaking && (
                  <div className={styles.fieldWrap}>
                    <label className={styles.label}>Welcome Message</label>
                    <input
                      className={styles.input}
                      placeholder="Enter welcome message"
                      value={welcomeMessage}
                      onChange={(e) => setWelcomeMessage(e.target.value)}
                      aria-label="Welcome Message"
                    />
                  </div>
                )}

                <div className={styles.fieldWrap}>
                  <label className={styles.label}>
                    Max Duration (seconds)
                    <span style={{ color: "red" }}>*</span>
                    <span className={styles.tooltipContainer}>
                      <GrFormView className={styles.viewicon} />
                      <span className={styles.tooltipText}>
                        Max Duration sets the time limit for the agent's response.<br />
                        It defines how long the AI can speak or generate output<br />
                        (in seconds) before stopping.
                      </span>
                    </span>
                  </label>
                  <input
                    type="number"
                    className={styles.input}
                    placeholder="Enter max duration"
                    value={maxDuration}
                    onChange={(e) => setMaxDuration(e.target.value)}
                    aria-label="Max Duration"
                  />
                </div>

                <div className={styles.fieldWrap}>
                  <label className={styles.label}>
                    Time Exceed Message
                    <span className={styles.tooltipContainer}>
                      <GrFormView className={styles.viewicon} />
                      <span className={styles.tooltipText}>
                        Time limit exceeded. The agent stopped responding.
                      </span>
                    </span>
                  </label>
                  <input
                    type="text"
                    className={styles.input}
                    placeholder="Enter time exceed message"
                    value={timeExceedMessage}
                    onChange={(e) => setTimeExceedMessage(e.target.value)}
                    aria-label="Time Exceed Message"
                  />
                </div>


                {inactivityMessages.map((msg, index) => (
                  <div className={styles.fieldWrap}>
                    <label className={styles.label}>
                      Inactivity Messages <span style={{ color: "red" }}>*</span>
                      <span className={styles.tooltipContainer}>
                        <GrFormView className={styles.viewicon} />
                        <span className={styles.tooltipText}>
                          Inactivity messages are sent when the user is silent for the specified durations.
                        </span>
                      </span>
                    </label>
                    <div
                      key={index}
                      style={{ display: "flex", gap: "10px", marginBottom: "10px", alignItems: "center" }}
                    >
                      <input
                        type="number"
                        className={styles.input}
                        placeholder="Duration (seconds)"
                        value={msg.duration}
                        onChange={(e) => handleInactivityMessageChange(index, "duration", e.target.value)}
                        aria-label={`Inactivity Duration ${index + 1}`}
                        style={{ width: "30%" }}
                      />
                      <input
                        type="text"
                        className={styles.input}
                        placeholder="Message"
                        value={msg.message}
                        onChange={(e) => handleInactivityMessageChange(index, "message", e.target.value)}
                        aria-label={`Inactivity Message ${index + 1}`}
                        style={{ width: "50%" }}
                      />
                      {/* <button
                        type="button"
                        className={styles.cancelBtn}
                        onClick={() => removeInactivityMessage(index)}
                        disabled={inactivityMessages.length === 1}
                        style={{ width: "20%" }}
                      >
                        Remove
                      </button> */}
                    </div>
                  </div>
                ))}

                {/* <div className={styles.fieldWrap}>
                    <label className={styles.label}>
                      Inactivity Add Button <span style={{ color: "red" }}>*</span>
                      <span className={styles.tooltipContainer}>
                        <GrFormView className={styles.viewicon} />
                        <span className={styles.tooltipText}>
                          Inactivity messages are sent when the user is silent for the specified durations.
                        </span>
                      </span>
                    </label>
                     <button
                  type="button"
                  className={styles.submitBtn}
                  onClick={addInactivityMessage}
                  style={{ marginTop: "10px" }}
                >
                  Add Inactivity Message
                </button>
                </div> */}



                <div className={styles.toggleRow}>
                  <span className={`${styles.label} ${styles.tooltipContainer}`}>
                    Enable Transcript
                    <span className={styles.tooltipText}>
                      Enable Transcript allows you to view a text<br />
                      version of the conversation between the AI<br />
                      and the user.
                    </span>
                  </span>
                  <label className={styles.switch}>
                    <input
                      type="checkbox"
                      checked={transcript}
                      onChange={() => setTranscript(!transcript)}
                      aria-label="Enable Transcript"
                    />
                    <span className={styles.sliderSwitch}></span>
                  </label>
                </div>

                <div className={styles.toggleRow}>
                  <span className={styles.label}>Enable Call Recording</span>
                  <label className={styles.switch}>
                    <input
                      type="checkbox"
                      checked={callRecording}
                      onChange={() => setCallRecording(!callRecording)}
                      aria-label="Enable Call Recording"
                    />
                    <span className={styles.sliderSwitch}></span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.buttonRow}>

            <button type="submit" className={styles.submitBtn}>
              Create Outbound Agent
            </button>
          </div>
        </form>

        {showCalcomPopup && (
          <div
            className={styles.popupOverlay}
            onClick={() => setShowCalcomPopup(false)}
          >
            <div
              className={styles.popupContent}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className={styles.popupTitle}>Enter Cal.com API Key</h3>
              <input
                type="text"
                className={styles.input}
                placeholder="Enter Cal.com API Key"
                value={calcomToken}
                onChange={(e) => setCalcomToken(e.target.value)}
                aria-label="Cal.com API Key"
              />
              <div className={styles.popupButtons}>
                <button
                  className={styles.submitBtn}
                  onClick={() => {
                    setShowCalcomPopup(false);
                  }}
                >
                  Save
                </button>
                <button
                  className={styles.cancelBtn}
                  onClick={() => setShowCalcomPopup(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {showCallTransferPopup && (
          <div
            className={styles.popupOverlay}
            onClick={() => setShowCallTransferPopup(false)}
          >
            <div
              className={styles.popupContent}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className={styles.popupTitle}>Enter Call Transfer Number</h3>
              <input
                type="text"
                className={styles.input}
                placeholder="Enter phone number (e.g., +1234567890)"
                value={callTransferNumber}
                onChange={(e) => setCallTransferNumber(e.target.value)}
                aria-label="Call Transfer Number"
              />
              <div className={styles.popupButtons}>
                <button
                  className={styles.submitBtn}
                  onClick={() => {
                    setShowCallTransferPopup(false);
                  }}
                >
                  Save
                </button>
                <button
                  className={styles.cancelBtn}
                  onClick={() => setShowCallTransferPopup(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {showWhatsappPopup && (
          <div
            className={styles.popupOverlay}
            onClick={() => setShowWhatsappPopup(false)}
          >
            <div
              className={styles.popupContent}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className={styles.popupTitle}>Enter WhatsApp Number</h3>
              <input
                type="text"
                className={styles.input}
                placeholder="Enter WhatsApp number (e.g., +1234567890)"
                value={whatsappNumber}
                onChange={(e) => setWhatsappNumber(e.target.value)}
                aria-label="WhatsApp Number"
              />
              <div className={styles.popupButtons}>
                <button
                  className={styles.submitBtn}
                  onClick={() => {
                    setShowWhatsappPopup(false);
                  }}
                >
                  Save
                </button>
                <button
                  className={styles.cancelBtn}
                  onClick={() => setShowWhatsappPopup(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {showTemplatePopup && (
          <div
            className={styles.popupOverlay}
            onClick={() => setShowTemplatePopup(false)}
          >
            <div
              className={styles.popupContent}
              onClick={(e) => e.stopPropagation()}
            >
              <h3 className={styles.popupTitle}>Select Template Image</h3>
              <div className={styles.templateImageGrid}>
                {templateImages.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`Template ${index + 1}`}
                    className={styles.templateImage}
                    onClick={() => handleTemplateImageSelect(image)}
                  />
                ))}
              </div>
              <div className={styles.popupButtons}>
                <button
                  className={styles.cancelBtn}
                  onClick={() => setShowTemplatePopup(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        <ToastContainer />
      </div>
    </div>
  );
};

export default CreateElectionOutBoundAgentComponent;